import React, { useState, useEffect } from 'react';
import Datatables from '../../utils/table/datatable';
import { ShipmentColumns } from 'helpers/DatatableColumns';
import { SHIPMENT, COURIER } from 'helpers/url_helper';
import { del, get, put } from 'helpers/api_helper';
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import Select from "react-select";

const Shipments = () => {
    const [ shipments, setShipments ] = useState([]);
    const [ courierPatner, setCourierPatner] = useState([]);
    const [ handleServiceChnage, setHandleServiceChnage ] = useState(null)
    const [ handleChnagePatner, setHandleChnagePatner ] = useState({
        shipping_patner: null,
        live_tracking_number: null
    })

    const [ pagination, setPagination ] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    useEffect(() => {
        const fetchData = async () => {
            const [courierResponse] = await Promise.all([
                get(`${COURIER}/options`)
            ]);
    
            if (courierResponse.success) setCourierPatner(courierResponse.data);
        };
    
        fetchData();
    }, [])

    const getAllShipments = async () => {
        const { success, data } = await get(`${SHIPMENT}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if (success) {
            setShipments(data);
        }
    }
    useEffect(() => {
        getAllShipments();
    }, [pagination]);

    const handleChnagePatnerLive = async() => {
        const t = {
            ...handleChnagePatner, id: handleServiceChnage
        }
        const { success, data } = await put(SHIPMENT, t);
        if(success){
            setHandleChnagePatner({
                shipping_patner: null,
                live_tracking_number: null
            });
            setHandleServiceChnage(null)
        }
    }

    const handleDelete = async (id) => {
        const { success, data } = await del(`${SHIPMENT}?id=${id}`);
        if (success) {
            getAllShipments();
        }
    }  
    
    return (
        <>
            <Datatables 
                isSearch={true}
                columns = {ShipmentColumns(setHandleServiceChnage, handleDelete)}
                showTableOnly={true}
                rowsLength = {shipments?.rows || 0}
                rows = {shipments?.data || []}
                keyField={'id'}
                handleAddButton={()=>{}}            
                title = "All Shipments"
                loading = {false}
                isAdd = {false}
                isTableHead = {true}
                ssr={setPagination}
            />

            {
                (handleServiceChnage != null) && <Modal size="lg" isOpen={handleServiceChnage != null}>
                        <div className='d-flex justify-content-between pt-3 ps-3 pe-3'>
                            <h5>Update Patner</h5>
                            <button onClick={() => setHandleServiceChnage(null)}>x</button>
                        </div>
                        <hr />
                        <ModalBody className='mt-0'>
                            <Row>
                                <Col>
                                    <label>Courier Patner</label>
                                    {/* <input className='form-control' onChange={(e) => { setHandleChnagePatner(p => ({...p, shipping_patner: e.target.value}))}} /> */}
                                    <Select
                                        // value={formData?.shipping_patner}
                                        onChange={(e) => setHandleChnagePatner(p => ({...p, shipping_patner: e.value}))}
                                        options={courierPatner}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Shipping Patner"
                                    />
                                </Col>
                                <Col>
                                    <label>Courier Patner</label>
                                    <input className='form-control' onChange={(e) => { setHandleChnagePatner(p => ({...p, live_tracking_number: e.target.value}))}} />
                                </Col>
                            </Row>
                            <Row className='mt-3 text-end'>
                                <Col>
                                    <button onClick={handleChnagePatnerLive} className='btn btn-primary'>Change Courier Partner</button>
                                </Col>
                            </Row>
                        </ModalBody>
                </Modal>
            }
        </>
    );
}

export default Shipments;